import React from "react";
import "./Carousel.scss";
import Songs from "../../Pages/Songs/Songs";
import Artists from "../../Pages/Artists/Artists";
import BestOf from "../../Pages/BestOf/BestOf";
import { useContext } from "react";
import { AppContext } from "../../../stores/application.store";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { isMobile } from "../../../services/agent";

const Carousel = () => {
  const vw = (px) => {
    return (px / 640) * 100;
  };

  const carRef = useRef();
  const { pageView } = useContext(AppContext);
  useEffect(() => {
    let pageName;
    switch (pageView) {
      case 1:
        pageName = "songs-page";
        break;
      case 2:
        pageName = "artists-page";
        break;
      case 3:
        pageName = "best-of-page";
        break;
      default:
        pageName = null;
        break;
    }
    if (pageName) {
      const el = document.querySelector("." + pageName);
      let height = el.clientHeight;
      carRef.current.style.height = height + 100 + "px";
    }
  }, [pageView]);
  return (
    <div className={`carousel page-${pageView}`} ref={carRef}>
      <div className="songs" id="page-1">
        <Songs />
      </div>
      <div className="artists" id="page-2">
        <Artists />
      </div>
      <div className="best-of" id="page-3">
        <BestOf />
      </div>
    </div>
  );
};

export default Carousel;
